module.exports = __webpack_public_path__ + "static/media/logo-livemax-kotler.684ca9d8.png";